"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const styles_1 = __importDefault(require("../../styles/styles"));
const colors_1 = __importDefault(require("../../styles/colors"));
const eventConstants_1 = require("../../constants/eventConstants");
const dateComponent_1 = __importDefault(require("../dateComponent/dateComponent"));
const button_1 = __importDefault(require("../button/button"));
const icon_1 = __importDefault(require("../icon/icon"));
const contactTable_1 = __importDefault(require("./contactsDetails/contactTable"));
const utils_1 = require("../../utils/utils");
const renderUserInfo = ({ item }) => {
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.minWidth, styles_1.default.marginFive] },
        react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlack }, item.content),
        react_1.default.createElement(react_native_paper_1.Paragraph, { style: styles_1.default.textColorGray }, item.title)));
};
const UserCustomerInfo = ({ user }) => {
    const [displayContacts, setDisplayContacts] = react_1.useState(false);
    const hasKeyAccount = !utils_1.isObjectEmpty(user.key_account);
    const data = [
        { id: '1', title: 'Name', content: `${user.first_name} ${user.last_name}` },
        { id: '2', title: 'E-mail', content: user.email },
        { id: '3', title: 'Phone Number', content: user.phone_number },
        {
            id: '4',
            title: 'Alternative Phone Number',
            content: user.alternative_phone_numbers ? user.alternative_phone_numbers[0] : '',
        },
        { id: '5', title: 'Mother Name', content: user.mothers_name },
        { id: '6', title: 'Monthly Income', content: user.monthly_income || '' },
        { id: '7', title: 'Gender', content: user.gender },
        { id: '8', title: 'Birth Date', content: user.date_of_birth || '' },
        { id: '9', title: 'State', content: user.state },
        { id: '10', title: 'Address', content: user.address },
        { id: '11', title: 'Date of Registration', content: react_1.default.createElement(dateComponent_1.default, { date: user.datetime_of_registration }) },
        { id: '12', title: 'Employment Status', content: user.employment_status },
        {
            id: '13',
            title: 'Suspended',
            content: user.is_suspended ? react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faWindowClose, color: colors_1.default.RED, size: 20 }) : '',
        },
        { id: '14', title: 'User System Status', content: user.user_system_status || '' },
        { id: '15', title: 'App Version', content: user.app_version },
    ];
    if (hasKeyAccount) {
        data.push({ id: '16', title: 'Cardinal', content: user.key_account.cardinal || '' }, { id: '17', title: 'User Status', content: user.key_account.user_status || '' }, {
            id: '18',
            title: 'Amount Obtainable',
            content: new Intl.NumberFormat('en-US').format(user.key_account.amount_obtainable),
        }, { id: '19', title: 'Last approved Product', content: user.key_account.last_approved_product || '' }, { id: '20', title: 'User Interest Rate', content: user.key_account.interest_rate || '' }, {
            id: '21',
            title: 'Date of last loan application',
            content: react_1.default.createElement(dateComponent_1.default, { date: user.key_account.last_application_datetime }),
        }, { id: '22', title: 'Origin', content: user.key_account.user_origin || '' });
    }
    const switchButton = () => {
        return (react_1.default.createElement(button_1.default, { onPress: () => setDisplayContacts(!displayContacts), text: displayContacts ? 'Display user details' : 'Display contacts', eventName: eventConstants_1.TOGGLE_DISPLAY_USER_CONTACTS }));
    };
    const userProfileContent = (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.alignItemsCenter] },
        react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, styles_1.default.paddingRightTen, styles_1.default.fontWeightBold] }, `User Information `),
        user.is_top_user && (react_1.default.createElement(react_native_paper_1.Chip, { avatar: react_1.default.createElement(icon_1.default, { size: 25, icon: free_solid_svg_icons_1.faCrown, color: colors_1.default.WHITE }), style: [
                styles_1.default.flexDirectionRow,
                styles_1.default.alignCenterCenter,
                styles_1.default.blueBackground,
                styles_1.default.paddingFour,
                styles_1.default.borderRadiusFour,
            ], textStyle: styles_1.default.textColorWhite }, `Premium `))));
    return (react_1.default.createElement(react_native_paper_1.Card, { style: [styles_1.default.whiteBackground, styles_1.default.marginTen, { minHeight: 460 }] },
        react_1.default.createElement(react_native_paper_1.Card.Title, { title: userProfileContent, left: ({ size }) => react_1.default.createElement(react_native_paper_1.Avatar.Icon, { size: size, icon: "account-cowboy-hat" }), right: switchButton, titleStyle: styles_1.default.textColorBlack }),
        react_1.default.createElement(react_native_paper_1.Card.Content, null, displayContacts ? (react_1.default.createElement(contactTable_1.default, { contacts: user.contacts })) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_native_1.FlatList, { data: data.filter((item) => item.content), renderItem: renderUserInfo, keyExtractor: (item) => item.id, numColumns: 4 }))))));
};
exports.default = UserCustomerInfo;
